import { render } from "./g-product-modal.vue?vue&type=template&id=7bada09a&ts=true"
import script from "./g-product-modal.vue?vue&type=script&lang=tsx"
export * from "./g-product-modal.vue?vue&type=script&lang=tsx"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__